import { render, staticRenderFns } from "./FBManagement.vue?vue&type=template&id=1b781732&scoped=true"
import script from "./FBManagement.vue?vue&type=script&lang=js"
export * from "./FBManagement.vue?vue&type=script&lang=js"
import style0 from "./FBManagement.vue?vue&type=style&index=0&id=1b781732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b781732",
  null
  
)

export default component.exports